import axios from 'axios';

const create = (data) => axios.post('/tags', data);
const get = (id) => axios.get(`/tags/${id}`);
const list = (params) => axios.get('/tags', { params });
const update = (id, tag) => axios.put(`/tags/${id}`, tag);
const remove = (id) => axios.delete(`/tags/${id}`, {});
const save = (tag) => {
  if (tag.id) {
    return update(tag.id, tag);
  }
  return create(tag);
};

export default {
  create,
  get,
  list,
  update,
  save,
  remove,
};
